import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var PerformingArts = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1 34.48c-.3.3-.8.3-1.2.1-.9-.5-2.7-1-5.1-1-2.3 0-4.2.5-5 1-.5.3-1.1.2-1.4-.3-.1-.2-.2-.4-.2-.6 0-.1 0-.299.1-.499 1.2-2.698 3.6-4.597 6.5-4.597s5.3 1.999 6.5 4.697c.2.4.1.9-.2 1.2ZM38.4 21.988c.5.3.7.899.4 1.399-.7 1.199-1.9 1.999-3.4 1.999s-2.7-.8-3.4-2c-.3-.499-.1-1.099.4-1.398.5-.3 1.1-.1 1.4.4.3.599.9.899 1.6.899.7 0 1.3-.4 1.6-.9.2-.5.9-.7 1.4-.4Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5 13.392c.3.2.5.5.5.9v17.59c0 3.298-1.7 6.296-4.4 7.995l-3.7 2.399a11.477 11.477 0 0 1-12.1 0L20 39.877c-1.3-.8-2.4-1.899-3.1-3.198-.3-.5-.1-1.1.4-1.399.5-.3 1.1-.1 1.4.4.6 1 1.4 1.899 2.4 2.498l3.7 2.399c3 1.899 6.8 1.899 9.9 0l3.7-2.399c2.2-1.399 3.5-3.698 3.5-6.296V15.89c-2.3.8-4.8 1.4-7.6 1.799-.6.1-1.1-.3-1.2-.9-.1-.6.3-1.099.9-1.199 3.2-.4 6.1-1.1 8.4-2.199.5-.2.8-.2 1.1 0ZM9.1 11.393c-.7 0-1.3.4-1.6.9-.3.5-.9.7-1.4.4-.5-.3-.7-.9-.4-1.4.7-1.199 1.9-1.998 3.4-1.998s2.7.8 3.4 1.999c.3.5.1 1.099-.4 1.399-.5.3-1.1.1-1.4-.4-.3-.6-.9-.9-1.6-.9ZM19.3 11.393c-.7 0-1.3.4-1.6.9-.3.5-.9.7-1.4.4-.5-.3-.7-.9-.4-1.4.7-1.199 1.9-1.998 3.4-1.998s2.7.8 3.4 1.999c.3.5.1 1.099-.4 1.399-.5.3-1.1.1-1.4-.4-.3-.6-.9-.9-1.6-.9Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4 0c-.2 0-.3 0-.4.1-3.4 1.5-7.9 2.399-12.8 2.399s-9.3-.9-12.8-2.4C1.1 0 .8 0 .5.2.2.4 0 .7 0 1v17.59c0 1.6.4 3.199 1.2 4.598.8 1.399 1.9 2.598 3.2 3.498l3.7 2.399c3.7 2.298 8.4 2.298 12.1 0l3.7-2.4c2.8-1.798 4.4-4.796 4.4-7.995V1C28.4.5 28 0 27.4 0Zm-1 18.59c0 2.598-1.3 4.897-3.5 6.296l-3.7 2.299a9.314 9.314 0 0 1-9.9 0l-3.7-2.4c-2.1-1.398-3.5-3.697-3.5-6.296V2.5c3.5 1.299 7.6 1.998 12.1 1.998s8.7-.7 12.1-1.998v16.09h.1Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 17.89c0 .1 0 .3-.1.4-1.2 2.698-3.7 4.697-6.7 4.697s-5.5-1.999-6.7-4.797c-.2-.4-.1-.9.3-1.2.3-.3.8-.3 1.2-.1.9.6 2.8 1 5.2 1 2.4 0 4.3-.5 5.2-1 .5-.3 1.1-.2 1.4.3.1.3.2.5.2.7Z"
  }));
});
PerformingArts.displayName = 'PerformingArts';
PerformingArts.defaultProps = {
  'aria-label': 'PerformingArts'
};
export default PerformingArts;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/PerformingArts.js
// module id = 3686
// module chunks = 11